namespace TabAurous.OMS {
    export namespace RewardsMasterService {
        export const baseUrl = 'OMS/RewardsMaster';

        export declare function Create(request: Serenity.SaveRequest<RewardsMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RewardsMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RewardsMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RewardsMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetRewards(request: RetailRequest, onSuccess?: (response: Serenity.ListResponse<RewardsMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/RewardsMaster/Create",
            Update = "OMS/RewardsMaster/Update",
            Delete = "OMS/RewardsMaster/Delete",
            Retrieve = "OMS/RewardsMaster/Retrieve",
            List = "OMS/RewardsMaster/List",
            GetRewards = "OMS/RewardsMaster/GetRewards"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetRewards'
        ].forEach(x => {
            (<any>RewardsMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
